import { getOnlyElementByAttribute } from './getOnlyElementByAttribute';

export const clonePlaceOrderButton = (checkoutDiv: HTMLElement) => {
  try {
    const placeOrderButton = getOnlyElementByAttribute(
      '[data-node-type="commerce-checkout-place-order-button"]'
    ) as HTMLElement;

    const placeOrderButtonClone = placeOrderButton.cloneNode(
      true
    ) as HTMLElement;

    placeOrderButton.after(placeOrderButtonClone);
    checkoutDiv.append(placeOrderButton);

    placeOrderButtonClone.removeAttribute('data-node-type');
    placeOrderButtonClone.setAttribute('data-fp', 'place-order-button-clone');
    placeOrderButton.style.display = 'none';

    return { placeOrderButton, placeOrderButtonClone };
  } catch (error) {
    throw error;
  }
};